"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LevelIcon = LevelIcon;
const react_1 = __importDefault(require("react"));
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const classnames_1 = __importDefault(require("classnames"));
const react_jss_1 = require("react-jss");
const LEVEL_COLOURS = ["#696969", "#2e762e", "#2e89ff", "#931093", "#e09429"];
const useStyles = (0, react_jss_1.createUseStyles)({
    wrapper: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: "4px",
        letterSpacing: "2px",
        fontSize: "12px",
        padding: "4px 6px",
        background: "#1d1d1d",
        color: "#fff",
    },
    icon: {
        // 2 levels per colour
        color: ({ amount }) => LEVEL_COLOURS[Math.floor((amount - 1) / 2)],
    },
});
function LevelIcon(props) {
    const classes = useStyles(props);
    const { amount, className, iconClassName, label = true } = props;
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(classes.wrapper, className) },
        label
            ? react_1.default.createElement("span", null,
                "lvl ",
                amount)
            : react_1.default.createElement("span", null, amount),
        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faSquareCaretUp, className: (0, classnames_1.default)(classes.icon, iconClassName) })));
}
